import Vue from 'vue'
import App from './App.vue'
import { router } from './router/router';
import './assets/css/main.less';
import {gotoUrl, baseUrl} from "./assets/js/mixin";
import 'animate.css';
import {httpClient,serviceName} from './utils/request'
import VueMeta from 'vue-meta'

Vue.prototype.http = httpClient
Vue.prototype.serviceName = serviceName
// 创建事件总线实例
Vue.prototype.$bus = new Vue();
Vue.prototype.baseUrl = baseUrl
Vue.config.productionTip = false
Vue.mixin(gotoUrl);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
Vue.use(VueMeta)
